import React, { ComponentProps } from "react";
import { Button, Flex, Text, Tooltip } from "@thenounproject/lingo-core";

type DisplayPanelButtonProps = {
  active?: boolean;
  label?: string;
  tooltipLabel?: string;
  tooltipSource?: string;
  onClick: () => void;
} & ComponentProps<typeof Button>;

export const DisplayPanelButton: React.FC<DisplayPanelButtonProps> = ({
  active,
  label,
  tooltipLabel,
  tooltipSource,
  onClick,
  ...buttonProps
}) => {
  // Extract flex from buttonProps if label is present
  const {
    flex,
    style,
    themeOverrides: passedThemeOverrides,
    ...buttonPropsWithoutFlex
  } = buttonProps;
  const actualButtonProps = label
    ? { ...buttonPropsWithoutFlex, width: "100%", style: { ...style } }
    : buttonProps;

  const buttonElement = (
    <>
      {tooltipLabel && (
        <Tooltip direction="top" source={tooltipSource} interactive={false}>
          {tooltipLabel}
        </Tooltip>
      )}
      <Button
        size="small"
        buttonStyle="primary"
        data-tooltip-source={tooltipSource}
        themeOverrides={{
          primaryColor: active ? "grayLight" : "none",
          primaryColorDark: "grayLight",
          primaryColorTint: "black",
          ...passedThemeOverrides,
        }}
        onClick={onClick}
        {...actualButtonProps}
      />
    </>
  );

  if (label) {
    return (
      <Flex flexDirection="column" alignItems="center" gap="4px" flex={flex} minWidth={0}>
        {buttonElement}
        <Text font="ui.extraTiny" color="grayDark">
          {label}
        </Text>
      </Flex>
    );
  }

  return buttonElement;
};
